const mainSearchForm = {
  flights: "Vluchten", // translated
  tours: "Rondleidingen", // translated
  hotel: "Hotel", // translated
  hotels: "Hotels", // translated
  services: "Diensten", // translated
  search: "ZOEKOPDRACHT", // translated
  destination: "Bestemming", // translated
  includedServices: "Inbegrepen services", // translated
  packageDuration: "Pakketduur:", // translated
  checkInOut: "Check in uit", // translated
  guests: "Gasten", // translated
  adults: "volwassenen", // translated
  children: "Kinderen", // translated
  child: "Kind", // translated
  age: "Leeftijd", // translated
  yearsOld: "Jaar oud", // translated
  rooms: "Kamers", // translated
  close: "Dichtbij", // translated
  searchType: "Zoektype", // translated
  accommodation: "Accommodatie", // translated
  transfers: "Overboekingen", // translated
  toursExperiences: "Rondleidingen/ervaringen", // translated
  nights: "Nachten", // translated
  days: "dagen", // translated
  packageType: "Pakkettype", // translated
  tourType: "Tourtype", // translated
  packages: "Pakketjes", // translated
  cars: "auto's", // translated
  cruises: "Cruises", // translated
  roundTrip: "Rondvaart", // translated
  isRoundTrip: "Is een rondreis", // translated
  passengers: "Passagiers", // translated
  origin: "Oorsprong", // translated
  departureReturn: "Vertrek- en retourdata", // translated
  infantsOnLap: "Baby's op schoot", // translated
  dream_packages: "Droompakketten", // translated
  thingsToDo: "Dingen om te doen", // translated
  infantsInSeat: "Baby's op de stoel", // translated
  airport: "Luchthaven", // translated
  partying: "Feesten", // translated
};


export default mainSearchForm;
